import { useState } from 'react'
import { exportsApi } from '../api/exports'
import { Button } from './ui'
import './shared.css'

/**
 * F-117 (REQ-265-001): "Stampa" e "Copia link" di una pratica o di un contatto. Prima dell'azione il server
 * registra l'evento in audit (`contract|contact.printed|shared`, senza contenuto); se il server rifiuta
 * (404 = scheda non visibile) l'azione non parte. Nessuna condivisione esterna: il link è lo stesso della pagina
 * e chi lo apre deve avere comunque i permessi.
 */
export function PrintShareButtons({
  entityType,
  entityId,
}: {
  entityType: 'Contract' | 'Contact'
  entityId: number
}) {
  const [busy, setBusy] = useState(false)
  const [message, setMessage] = useState('')

  async function print() {
    setBusy(true)
    setMessage('')
    try {
      await exportsApi.accessEvent('print', entityType, entityId)
      window.print()
    } catch (e) {
      setMessage(e instanceof Error ? e.message : 'Stampa non registrata')
    } finally {
      setBusy(false)
    }
  }

  async function copyLink() {
    setBusy(true)
    setMessage('')
    try {
      await exportsApi.accessEvent('share', entityType, entityId)
      await navigator.clipboard.writeText(window.location.href)
      setMessage('Link copiato')
    } catch (e) {
      setMessage(e instanceof Error ? e.message : 'Link non copiato')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="ecrm-inline-actions d-print-none">
      <Button variant="outlined" size="sm" icon="print" disabled={busy} onClick={() => void print()}>
        Stampa
      </Button>
      <Button variant="outlined" size="sm" icon="link" disabled={busy} onClick={() => void copyLink()}>
        Copia link
      </Button>
      {message && <span className="ecrm-inline-message" role="status">{message}</span>}
    </div>
  )
}
